<template>

        <div class="container">
            <div class="bottom20">&nbsp;</div>
            <H1 class="is-size-3 has-text-white">EMAIL VERIFIED</H1>
            <div class="limitWidth">
                <hr/>
            </div>
            <div class="has-text-white">
                Thank you! Your email has been verified. Please login:
                <br><br>
                <button class="button is-coolGreen bottom40" @click="doLogin">LOG IN</button>
            </div>
        </div>

</template>

<script>


export default {
  components: {
   
  },
  mounted: function () {
    // TODO: read from ?cookie? to see if there was a checkout pending before registration and
    // verification happened, and if so nav to checkout.
    // Also consider storing cart on server session?
    // Or maybe setting timestamp on cart and if older than x minutes clearing it?

    // alert(document.cookie)
  },
  methods: {
    doLogin: function () {
      this.$root.app.showModalLogin({ message: '' })
      this.$router.push('/')
    }
  }
}
</script>
